module.exports = __webpack_public_path__ + "static/media/doug-404.f3e2e794.png";